import MuiCardActions from '@mui/material/CardActions'
import { FC } from 'react'

import { CardFooterProps } from './card-footer.types'

export const CardFooter: FC<CardFooterProps> = ({ children, ...props }) => {
  return <MuiCardActions {...props}>{children}</MuiCardActions>
}
